import React, { useEffect } from "react";
import "./styles/common.css";
import "./styles/base.css";
import AOS from "aos";
import "aos/dist/aos.css";

import mainIconImage1 from "./assets/main-01-icon01.png";
import mainIconImage2 from "./assets/main-01-icon02.png";
import neatHomeImage from "./assets/neat_home.jpg";
import neatHomeImage2 from "./assets/1593066590.png";
import neatHomeImage3 from "./assets/cj_image.png";
import MySwiper from "./MySwiper";
import line from "./assets/line.png";

const logoImages = [
  "logo_14.jpg",
  "logo_03.png",
  "logo_02.png",
  "logo_05.png",
  "logo_09.png",
  "logo_01.png",
  "logo_04.png",
  "logo_07.png",
  "logo_08.png",
  "logo_10.png",
  "logo_15.png",
  "logo_25.png",
  "logo_12.png",
  "logo_16.png",
  "logo_13.png",
  "logo_24.png",
];

const logoImages02 = [
  "logo_22.jpg",
  "logo_18.jpg",
  "logo_17.png",
  "logo_19.png",
  "logo_23.png",
  "logo_20.png",
  "logo_21.png",
];

const logoImages03 = [
  "logo_26.png",
  "logo_28.png",
  "logo_29.png",
  "logo_31.png",
  "logo_30.png",
  "logo_27.png",
];

const Home: React.FC = () => {
  useEffect(() => {
    AOS.init({
      duration: 700,
      offset: 100,
      easing: "ease-in-out",
      once: false,
    });

    window.addEventListener("scroll", () => {
      AOS.refresh();
    });
  }, []);

  return (
    <div>
      <div id="main">
        <div className="main-visual">
          <MySwiper />
          <div className="slide-text">
            <div className="wr">
              <p>
                <b>농림 정보화에 앞장선 기업</b>
              </p>
              <p className="p-text">
                <b>주식회사 제닉스</b>
              </p>
              <p>
                <br />
                농림, 축산, 식품 분야의 IT 시스템 구축 및 통합유지 보수 사업을
                통해 농림 정보화를 선도하고 있으며, <br />
                다년간 축적된 경험과 전문 기술력을 바탕으로 한 최적의 정보
                시스템 서비스를 제공하는 IT 전문 기업입니다.
              </p>
            </div>
          </div>
        </div>
        <div
          className="cont-01 cont-wr"
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-duration="500"
        >
          <div className="wr">
            <h3 className="main-tit">
              <small>JENIX SERVICE</small>
              앞선 기술력과 혁신적인 사고로 최적의 서비스를 제공
            </h3>
            <ul>
              <li>
                <a>
                  <img
                    src={mainIconImage1}
                    alt="End to End Professional Services"
                  />
                  <h4>Agricultural and Forestry Informatization</h4>
                  <p>농림유통 및 축산정보화의 혁신적 시스템 제공</p>
                </a>
              </li>
              <li>
                <a>
                  <img src={mainIconImage2} alt="HybridIT Infra" />
                  <h4>정보 보호</h4>
                  <p>정보 보호 컨설팅, 모의 해킹</p>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="cont-03 cont-wr">
          <div
            className="wr"
            data-aos="fade-up"
            data-aos-delay="100"
            data-aos-duration="500"
          >
            <h3 className="main-tit">
              <small>JENIX RESULTS</small>
              고객과 제닉스가 함께 구축한 세상
            </h3>
            <ul>
              <li>
                <a>
                  <div
                    className="img"
                    style={{ backgroundImage: `url(${neatHomeImage3})` }}
                  ></div>
                  <div className="box">
                    <h4>CJ프레시웨이 FS 메뉴관리 시스템 구축</h4>
                    <p>
                      2023.01~2023.12
                      <br />
                      CJ프레시웨이
                    </p>
                  </div>
                </a>
              </li>
              <li>
                <a>
                  <div
                    className="img"
                    style={{ backgroundImage: `url(${neatHomeImage})` }}
                  ></div>
                  <div className="box">
                    <h4>공공 급식 통합 플래폼 구축</h4>
                    <p>
                      2021.05~2022.10
                      <br />
                      한국농수산식품유통공사
                    </p>
                  </div>
                </a>
              </li>
              <li>
                <a>
                  <div
                    className="img"
                    style={{ backgroundImage: `url(${neatHomeImage2})` }}
                  ></div>
                  <div className="box">
                    <h4>사이버거래소 응용프로그램위탁운영</h4>
                    <p>
                      2020.01~2022.12
                      <br />
                      한국농수산식품유통공사
                    </p>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="cont-02 cont-wr">
          <div className="wr">
            <div
              className="alli-slider"
              data-aos="fade-up"
              data-aos-delay="100"
              data-aos-duration="500"
            >
              <div className="cont-tit">
                <h3 className="main-tit">
                  <small>JENIX PARTNER</small>
                  시스템개발(System Integration)
                </h3>
                <ul>
                  {logoImages.map((imageName, index) => (
                    <li>
                      <img
                        src={require(`./assets/logo/${imageName}`)}
                        alt=""
                        key={index}
                      />
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className="alli-slider"
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="500"
              >
                <div className="cont-tit">
                  <div className="img center">
                    <img src={line} alt="" />
                  </div>
                  <h3 className="main-tit">보안컨설팅</h3>
                  <ul>
                    {logoImages02.map((imageName, index) => (
                      <li>
                        <img
                          src={require(`./assets/logo/${imageName}`)}
                          alt=""
                          key={index}
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div
                className="alli-slider"
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="500"
              >
                <div className="cont-tit">
                  <div className="img center">
                    <img src={line} alt="" />
                  </div>
                  <h3 className="main-tit">솔루션</h3>
                  <ul>
                    {logoImages03.map((imageName, index) => (
                      <li>
                        <img
                          src={require(`./assets/logo/${imageName}`)}
                          alt=""
                          key={index}
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
